import { render, staticRenderFns } from "./CarrierDestinationList.vue?vue&type=template&id=54043f10&scoped=true&"
import script from "./CarrierDestinationList.vue?vue&type=script&lang=js&"
export * from "./CarrierDestinationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54043f10",
  null
  
)

export default component.exports